import { Fragment } from 'react';

import { range } from '@labradorsports/utils';

import { FieldLogo } from '../../components/index.js';

/**
 * Field dimensions:
 *  53 x 120 (yards)
 *  */
const MensFullFieldBackdrop: FC<any> = ({ fieldViewport, backgroundImage }) => {
    const fieldWidth = 53;
    const fieldHeight = 120;

    return (
        <g className="field-backdrop">
            {/* Field Outline */}
            <rect
                x={fieldViewport.flippedX ? fieldViewport.getPixelX(fieldWidth) : fieldViewport.getPixelX(0)}
                y={fieldViewport.flipped ? fieldViewport.getPixelY(fieldHeight) : fieldViewport.getPixelY(0)}
                width={fieldViewport.getPixelLength(fieldWidth)}
                height={fieldViewport.getPixelLength(fieldHeight)}
                fill="none"
            />

            {/* Top Logos */}
            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: 10, y: 35 }}
                size={12}
                rotation={90}
            />
            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: fieldWidth - 10, y: 35 }}
                size={12}
                rotation={-90}
            />

            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: 10, y: fieldHeight - 35 }}
                size={12}
                rotation={90}
            />
            <FieldLogo
                backgroundImage={backgroundImage}
                fieldViewport={fieldViewport}
                centeredOn={{ x: fieldWidth - 10, y: fieldHeight - 35 }}
                size={12}
                rotation={-90}
            />

            {range(101).map((i) => {
                const yard = i + 10;

                return yard % 5 === 0 ? (
                    <line
                        key={yard}
                        x1={fieldViewport.getPixelX(0)}
                        y1={fieldViewport.getPixelY(yard)}
                        x2={fieldViewport.getPixelX(fieldWidth)}
                        y2={fieldViewport.getPixelY(yard)}
                    />
                ) : (
                    <Fragment key={yard}>
                        {/* Left */}
                        <line
                            x1={fieldViewport.getPixelX(fieldWidth / 2 - 10)}
                            y1={fieldViewport.getPixelY(yard)}
                            x2={fieldViewport.getPixelX(fieldWidth / 2 - 9)}
                            y2={fieldViewport.getPixelY(yard)}
                        />

                        {/* Right */}
                        <line
                            x1={fieldViewport.getPixelX(fieldWidth / 2 + 9)}
                            y1={fieldViewport.getPixelY(yard)}
                            x2={fieldViewport.getPixelX(fieldWidth / 2 + 10)}
                            y2={fieldViewport.getPixelY(yard)}
                        />
                    </Fragment>
                );
            })}

            <text
                dx={fieldViewport.flippedX ? fieldViewport.getPixelX(0) - 5 : fieldViewport.getPixelX(fieldWidth) - 5}
                dy={fieldViewport.flipped ? fieldViewport.getPixelY(0) - 5 : fieldViewport.getPixelY(fieldHeight) - 5}
                textAnchor="end"
                strokeWidth="0"
                fill="#aaa"
                fontSize=".8em"
            >
                FootballLab.com
            </text>
        </g>
    );
};

export default MensFullFieldBackdrop;
